import http from './http';
import { paramApiGateway } from '@/utils/config';

export class RestService {
    async getAllSessionStudents(environment: string, classSessionId: string) {
        const url = `${paramApiGateway}/sessions?environment=${environment}&operation=getStudentsList&classSessionId=${classSessionId}`;
        const response = await http.get(url);
        if (response.data.statusCode === 200) {
            return response.data.body;
        } else {
            throw new Error(response.data.message);
        }
    }

    async getAllSessionDataLogs(environment: string, classSessionId: string, studentId: string) {
        const url = `${paramApiGateway}/sessions?environment=${environment}&operation=getData&classSessionId=${classSessionId}&studentId=${studentId}`;
        const response = await http.get(url);
        if (response.data.statusCode === 200) {
            return response.data.body;
        } else {
            throw new Error(response.data.message);
        }
    }

    async getSessionImage(environment: string, filePath: string) {
        const url = `${paramApiGateway}/sessions?environment=${environment}&operation=getImage&filePath=${encodeURIComponent(filePath)}`;
        const response = await http.get(url);
        if (response.data.statusCode === 200) {
            return response.data.body;
        } else {
            throw new Error(response.data.message);
        }
    }

    async postHumanClassification(classificationObject: any) {
        const url = `${paramApiGateway}/sessions?environment=${classificationObject.environment}`;
        const response = await http.post(url, classificationObject);
        if (response.data.statusCode === 200) {
            return response.data.message;
        } else {
            throw new Error(response.data.message);
        }
    }

    async postTabClassification(tabClassificationObject: any) {
        const url = `${paramApiGateway}/sessions?environment=${tabClassificationObject.environment}`;
        const response = await http.post(url, tabClassificationObject);
        if (response.data.statusCode === 200) {
            return response.data.message;
        } else {
            throw new Error(response.data.message);
        }
    }

    async getClassAccuracy(environment: string, classSessionId: string) {
        const url = `${paramApiGateway}/sessions?environment=${environment}&operation=getClassAccuracy&classSessionId=${classSessionId}`;
        const response = await http.get(url);
        if (response.data.statusCode === 200) {
            return response.data.body;
        } else {
            throw new Error(response.data.message);
        }
    }

    async getTriageReport(environment: string) {
        const url = `${paramApiGateway}/sessions?environment=${environment}&operation=getTriageReport`;
        const response = await http.get(url);
        if (response.data.statusCode === 200) {
            return response.data.body;
        } else {
            throw new Error(response.data.message);
        }
    }
}
